module.exports = __webpack_public_path__ + "img/flags/DO.5dd522e.png";